export default "__VITE_ASSET__BCR9tNGh__"